import React from "react";
import { Button, ButtonGroup, HStack, Text } from "@chakra-ui/react";

const getVisiblePages = (currentPage, totalPages) => {
  if (totalPages <= 5) return Array.from({ length: totalPages }, (_, index) => index + 1);

  const start = Math.max(1, currentPage - 1);
  const end = Math.min(totalPages, start + 2);
  const adjustedStart = Math.max(1, end - 2);

  return Array.from({ length: end - adjustedStart + 1 }, (_, index) => adjustedStart + index);
};

const PaginationControls = ({ currentPage, totalPages, onPageChange }) => {
  const pages = getVisiblePages(currentPage, totalPages);

  return (
    <HStack
      mt={4}
      spacing={3}
      justify="space-between"
      align={{ base: "stretch", sm: "center" }}
      flexWrap="wrap"
    >
      <Text fontSize="sm" color="gray.500">
        Page {currentPage} of {totalPages}
      </Text>

      <ButtonGroup size="sm" isAttached={false} flexWrap="wrap">
        <Button onClick={() => onPageChange(currentPage - 1)} isDisabled={currentPage <= 1}>
          Previous
        </Button>
        {pages.map((page) => (
          <Button
            key={page}
            onClick={() => onPageChange(page)}
            variant={page === currentPage ? "solid" : "outline"}
            colorScheme={page === currentPage ? "blue" : "gray"}
          >
            {page}
          </Button>
        ))}
        <Button
          onClick={() => onPageChange(currentPage + 1)}
          isDisabled={currentPage >= totalPages}
        >
          Next
        </Button>
      </ButtonGroup>
    </HStack>
  );
};

export default PaginationControls;
